export const QUEUE_STATUS_EP = {
  getNewList: "/manager/queue_new",
  getQueues: "/clients/listQueue",
};
